<template>
  <div class="go-in">
    <banner title="关于我们" subtitle="ABOUT US" />
    <div class="go-in-section" v-loading="loading">
      <div class="container">
        <!-- 内容导航 -->
        <nav class="page-nav">
          <a
            v-for="sec in sections"
            :key="sec.id"
            class="page-nav-item"
            :class="{ 'is-active': activeSection === sec.id }"
            @click="scrollTo(sec.id)"
          >{{ sec.label }}</a>
        </nav>

        <!-- 公司简介 -->
        <div id="profile" class="block">
          <div class="block-head">
            <h3>公司简介</h3>
            <p>COMPANY PROFILE</p>
          </div>
          <div class="intro">
            <img class="intro-photo" src="../assets/img/jianjietopmin.png" alt="公司简介" />
            <p class="intro-text">{{ companyIntro }}</p>
          </div>
        </div>

        <!-- 发展历程 -->
        <div id="course" class="block">
          <div class="block-head">
            <h3>发展历程</h3>
            <p>DEVELOPMENT</p>
          </div>
          <div class="timeline-h">
            <div v-if="!flatCourse.length" class="empty">暂无发展历程数据</div>
            <div v-else class="timeline-h-track">
              <div class="timeline-h-axis"></div>
              <div
                v-for="(item, index) in flatCourse"
                :key="index"
                class="timeline-h-item"
                :class="{ 'is-above': index % 2 === 0, 'is-below': index % 2 === 1 }"
              >
                <div class="timeline-h-year">{{ item.Year }}</div>
                <span class="timeline-h-node"></span>
                <div class="timeline-h-card">
                  <el-tooltip placement="top" effect="light" :show-after="100">
                    <template slot="content">
                      <div class="timeline-tip-body">{{ item.Content }}</div>
                    </template>
                    <div class="timeline-h-text">{{ item.Content }}</div>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 公司愿景 -->
        <div id="culture" class="block">
          <div class="block-head">
            <h3>公司愿景</h3>
            <p>CULTURE</p>
          </div>
          <div class="culture">
            <p class="culture-slogan">{{ cultureSlogan }}</p>
            <ul class="culture-items">
              <li v-for="(item, index) in cultureItems" :key="index">{{ item }}</li>
            </ul>
          </div>
        </div>

        <!-- 公司荣誉 -->
        <div id="honor" class="block">
          <div class="block-head">
            <h3>公司荣誉</h3>
            <p>HONOR</p>
          </div>
          <ul class="honor-grid">
            <li
              v-for="(honor, index) in pagedHonorList"
              :key="index"
              @click="dialogTableVisible = true; dialogUrl = $img(honor.Img); dialogTitle = honor.Remark"
            >
              <div class="honor-img">
                <img v-lazy="$img(honor.Img)" :alt="honor.Remark" />
              </div>
            </li>
          </ul>
          <p v-if="honorList.length" class="hint">点击图片查看大图</p>
          <p v-if="!loading && !honorList.length" class="empty">暂无荣誉数据</p>
          <el-pagination
            v-if="honorList.length > honorPageSize"
            class="honor-pager"
            :layout="honorPagerLayout"
            :page-size="honorPageSize"
            :current-page.sync="honorPage"
            :total="honorList.length"
            :small="isHonorPagerSmall"
            background
          />
        </div>

        <!-- 核心团队 -->
        <div id="expert" class="block">
          <div class="block-head">
            <h3>核心团队</h3>
            <p>OUR EXPERTS</p>
          </div>
          <ul v-if="expertList.length" class="expert-grid">
            <li v-for="(m, index) in expertList" :key="m.Id || index" class="expert-card">
              <div class="expert-photo">
                <img v-lazy="$img(m.Photo)" :alt="m.Name" />
              </div>
              <div class="expert-info">
                <span v-if="m.Title" class="expert-title">{{ m.Title }}</span>
                <h4 class="expert-name">{{ m.Name }}</h4>
                <el-tooltip
                  v-if="m.Bio"
                  placement="top"
                  effect="light"
                  :show-after="100"
                >
                  <template slot="content">
                    <div class="expert-tip-body">{{ m.Bio }}</div>
                  </template>
                  <p class="expert-bio">{{ m.Bio }}</p>
                </el-tooltip>
              </div>
            </li>
          </ul>
          <p v-else-if="!loading" class="empty">暂无核心团队数据</p>
        </div>

        <!-- 团队风采 -->
        <div id="team" class="block">
          <div class="block-head">
            <h3>团队风采</h3>
            <p>OUR TEAM</p>
          </div>
          <el-carousel :interval="4000" height="480px">
            <el-carousel-item v-for="(team, index) in teamItem" :key="index">
              <div class="team-slide" v-lazy:background-image="$img(team.Img)"></div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <!-- 合作伙伴 -->
        <div id="partner" class="block">
          <div class="block-head">
            <h3>合作伙伴</h3>
            <p>PARTNERS</p>
          </div>
          <ul class="partner-grid">
            <li v-for="(partner, i) in partnerImg" :key="i">
              <img v-lazy="$img(partner.Img)" alt="合作伙伴" />
            </li>
          </ul>
          <p v-if="!loading && !partnerImg.length" class="empty">暂无合作伙伴数据</p>
        </div>
      </div>

      <!-- 荣誉大图弹窗 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible" width="60%">
        <img v-if="dialogUrl" v-lazy="dialogUrl" :alt="dialogTitle" class="dialog-img" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";

export default {
  components: { Banner },
  data() {
    return {
      loading: true,
      honorList: [],
      partnerImg: [],
      courseList: [],
      teamItem: [],
      companyIntro: "",
      cultureSlogan: "务实 · 创新 · 协同 · 精益",
      cultureItems: ["航测遥感", "北斗应用", "无人机研产", "三维地信服务"],
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: "",
      activeSection: "profile",
      honorPage: 1,
      honorPageSize: 15,
      expertList: [],
      isMobile: false,
      sections: [
        { id: "profile", label: "公司简介" },
        { id: "course", label: "发展历程" },
        { id: "culture", label: "公司愿景" },
        { id: "honor", label: "公司荣誉" },
        { id: "expert", label: "核心团队" },
        { id: "team", label: "团队风采" },
        { id: "partner", label: "合作伙伴" }
      ]
    };
  },
  computed: {
    flatCourse() {
      const arr = [];
      (this.courseList || []).forEach(group => {
        (group || []).forEach(item => arr.push(item));
      });
      return arr;
    },
    pagedHonorList() {
      const start = (this.honorPage - 1) * this.honorPageSize;
      return this.honorList.slice(start, start + this.honorPageSize);
    },
    // 手机端分页:只用 prev/pager/next,去掉 jumper 和 total 避免溢出
    honorPagerLayout() {
      return this.isMobile ? "prev, pager, next" : "prev, pager, next, jumper, total";
    },
    isHonorPagerSmall() {
      return this.isMobile;
    }
  },
  mounted() {
    this.calcHonorPageSize();
    this.updateViewport();
    this.$http
      .all([
        this.$http.get("Honor"),
        this.$http.get("Enterprise"),
        this.$http.get("Team"),
        this.$http.get("Course"),
        this.$http.get("DataDictionary")
      ])
      .then(
        this.$http.spread(
          (responseHonor, responseEnterprise, responseTeam, responseCourse, responseDict) => {
            this.honorList = responseHonor.data || [];
            this.partnerImg = responseEnterprise.data || [];
            this.teamItem = responseTeam.data || [];

            const courseData = responseCourse.data || [];
            this.courseList = [];
            const groupCount = Math.ceil(courseData.length / 2);
            for (let i = 0; i < groupCount; i++) {
              const img2 = [];
              for (let j = 0; j < 2; j++) {
                if (courseData.length - 1 >= i * 2 + j) {
                  img2.push(courseData[i * 2 + j]);
                }
              }
              this.courseList.push(img2);
            }

            const dictMap = {};
            (responseDict.data || []).forEach(item => {
              if (item && item.Key) dictMap[item.Key] = item.Content;
            });
            if (dictMap.CompanyIntro) this.companyIntro = dictMap.CompanyIntro;
            if (dictMap.CultureSlogan) this.cultureSlogan = dictMap.CultureSlogan;
            const items = [
              dictMap.CultureItem1,
              dictMap.CultureItem2,
              dictMap.CultureItem3,
              dictMap.CultureItem4
            ].filter(Boolean);
            if (items.length) this.cultureItems = items;

            this.loading = false;
          }
        )
      )
      .catch(() => {
        this.loading = false;
      });

    window.addEventListener("scroll", this.onScroll);
    window.addEventListener("resize", this.calcHonorPageSize);
    window.addEventListener("resize", this.updateViewport);

    this.loadExpert();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.calcHonorPageSize);
    window.removeEventListener("resize", this.updateViewport);
  },
  methods: {
    loadExpert() {
      // 一次拉取全部数据(门户端不做分页)
      this.$http
        .get("Expert?page=1&size=1000")
        .then(response => {
          const data = response.data || {};
          this.expertList = data.Items || data.items || [];
        })
        .catch(() => {
          this.expertList = [];
        });
    },
    scrollTo(id) {
      const el = document.getElementById(id);
      if (!el) return;
      const top = el.getBoundingClientRect().top + window.pageYOffset - 68;
      window.scrollTo({ top, behavior: "smooth" });
    },
    onScroll() {
      let current = this.sections[0].id;
      this.sections.forEach(sec => {
        const el = document.getElementById(sec.id);
        if (el && el.getBoundingClientRect().top <= 100) current = sec.id;
      });
      this.activeSection = current;
    },
    calcHonorPageSize() {
      const w = window.innerWidth;
      let cols = 5;
      if (w <= 640) cols = 2;
      else if (w <= 960) cols = 3;
      else if (w <= 1100) cols = 4;
      this.honorPageSize = cols * 3;
    },
    updateViewport() {
      this.isMobile = window.innerWidth <= 640;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/variables.scss";

.go-in {
  width: 100%;
  background: $color-bg-2;
  padding-bottom: 60px;
}

.go-in-section {
  padding: 28px 0 0;
}

// 内容导航
.page-nav {
  display: flex;
  flex-wrap: wrap;
  background: #fff;
  border: 1px solid $color-border;
  border-bottom: 2px solid $color-border;
  margin-bottom: 24px;
  position: sticky;
  top: 0;
  z-index: 20;

  // ≤640px 改为横向滚动,避免 7 个 tab 挤成 2 行参差不齐
  @media (max-width: 640px) {
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    &::-webkit-scrollbar { display: none; }
  }
}

.page-nav-item {
  // 手机端禁止收缩,保持可读宽度
  @media (max-width: 640px) {
    flex-shrink: 0;
  }
}

.page-nav-item {
  padding: 14px 28px;
  font-size: 14px;
  color: $color-text-2;
  cursor: pointer;
  border-right: 1px solid $color-border;
  position: relative;
  letter-spacing: 1px;
  transition: color 0.2s ease;

  &:hover { color: $color-accent; }

  &.is-active {
    color: $color-accent;
    font-weight: 600;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: -2px;
      height: 2px;
      background: $color-accent;
    }
  }
}

// 通用区块
.block {
  background: #fff;
  border: 1px solid $color-border;
  margin-bottom: 24px;
  padding: 24px;

  &:last-child { margin-bottom: 0; }
}

.block-head {
  border-left: 4px solid $color-accent;
  padding-left: 12px;
  margin-bottom: 24px;

  h3 {
    margin: 0;
    font-size: $font-size-title;
    font-weight: 600;
    color: $color-text;
    letter-spacing: 1px;
  }

  p {
    margin: 4px 0 0;
    font-size: 12px;
    letter-spacing: 2px;
    color: $color-text-3;
    text-transform: uppercase;
  }
}

// 公司简介
.intro {
  display: grid;
  // minmax(0, 1fr) 锁死最小宽度为 0,避免右侧文字内容超长把左侧照片列压扁
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.4fr);
  gap: 28px;
  align-items: stretch;

  .intro-photo {
    width: 100%;
    height: 320px;
    object-fit: cover;
    border: 1px solid $color-border;
  }

  .intro-text {
    margin: 0;
    color: $color-text;
    font-size: 14px;
    line-height: 1.9;
    text-indent: 2em;
    text-align: justify;
  }
}

// 发展历程(横向时间轴:flex 单行 + 横向滚动,所有 item 在同一行,
// 节点永远居中穿过一条轴线;is-above/is-below 互放卡片与年份)
.timeline-h {
  padding: 24px 0 0;
}

.timeline-h-track {
  position: relative;
  display: flex;
  align-items: stretch;
  gap: 16px;
  padding: 0 4px;
  // 容器窄时横向滚动,绝不换行(避免节点错位)
  overflow-x: auto;
  overflow-y: hidden;
}

.timeline-h-axis {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  height: 2px;
  background: $color-border-dark;
  z-index: 1;
  pointer-events: none;
}

.timeline-h-item {
  // 1 0 160px:最小 160px,容器有富余时平均分摊,容器窄时保持 160px 并触发横向滚动
  flex: 1 0 160px;
  min-width: 160px;
  position: relative;
  display: grid;
  grid-template-rows: 1fr 28px 1fr;
  min-height: 240px;
  text-align: center;
}

.timeline-h-year {
  font-size: 18px;
  font-weight: 700;
  color: $color-primary;
  letter-spacing: 1px;
  padding: 4px 6px;
  background: #fff;
  align-self: center;
}

.timeline-h-node {
  grid-row: 2;
  align-self: center;
  justify-self: center;
  width: 14px;
  height: 14px;
  background: $color-accent;
  border: 2px solid #fff;
  box-shadow: 0 0 0 1px $color-border-dark;
  z-index: 2;
}

.timeline-h-card {
  background: #fff;
  border: 1px solid $color-border;
  padding: 12px 14px;
  text-align: center;
  font-size: 12px;
  line-height: 1.7;
  color: $color-text-2;
}

// 偶数:卡片在上(行 1),年份在下(行 3)
.timeline-h-item.is-above .timeline-h-card {
  grid-row: 1;
  align-self: end;
}
.timeline-h-item.is-above .timeline-h-year {
  grid-row: 3;
  align-self: start;
}

// 奇数:年份在上(行 1),卡片在下(行 3)
.timeline-h-item.is-below .timeline-h-year {
  grid-row: 1;
  align-self: end;
}
.timeline-h-item.is-below .timeline-h-card {
  grid-row: 3;
  align-self: start;
}

.timeline-h-text {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

// 企业文化
.culture {
  background: $color-bg-2;
  border: 1px solid $color-border;
  border-left: 4px solid $color-accent;
  padding: 28px 32px;

  .culture-slogan {
    margin: 0 0 16px;
    font-size: 20px;
    color: $color-primary;
    letter-spacing: 2px;
    font-weight: 600;
  }

  .culture-items {
    display: grid;
    // minmax(0, 1fr) 锁死最小宽度为 0,内容超长会换行而不是撑大列
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px 24px;

    li {
      color: $color-text;
      font-size: 14px;
      line-height: 1.9;
      padding-left: 16px;
      position: relative;

      &::before {
        content: "■";
        position: absolute;
        left: 0;
        top: 0;
        color: $color-accent;
        font-size: 10px;
        line-height: 1.9;
      }
    }
  }
}

// 公司荣誉
.honor-grid {
  display: grid;
  // minmax(0, 1fr) 锁死最小宽度为 0,5 列严格等宽,长名称内部换行不撑列
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 14px;

  li {
    cursor: pointer;
    border: 1px solid $color-border;
    background: #fff;
    transition: border-color 0.2s ease;
    padding: 0;
    overflow: hidden;

    &:hover {
      border-color: $color-accent;
    }

    .honor-img {
      width: 100%;
      aspect-ratio: 3 / 2;
      overflow: hidden;
      background: $color-bg-2;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
}

.honor-pager {
  margin-top: 22px;
  text-align: center;
}

.hint {
  text-align: center;
  color: $color-text-3;
  font-size: 12px;
  margin: 14px 0 0;
}

.empty {
  text-align: center;
  color: $color-text-3;
  padding: 30px 0;
  margin: 0;
}

// 团队风采
.team-slide {
  width: 100%;
  height: 100%;
  // 等比例放大显示,中心点对齐(以图片正中位置为裁剪锚点)
  background: #e8e8e8 no-repeat center / cover;
  background-position: center center;
  border: 1px solid $color-border;
}

// 核心团队(2 列网格,左头像 + 右文字栏)
.expert-grid {
  display: grid;
  // minmax(0, 1fr) 锁死最小宽度为 0,长名字/长介绍不会挤掉对方
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
}

.expert-card {
  display: flex;
  gap: 22px;
  padding: 24px;
  background: #fff;
  border: 1px solid $color-border;
  transition: border-color 0.2s ease;

  &:hover { border-color: $color-accent; }
}

.expert-photo {
  width: 120px;
  height: 120px;
  flex-shrink: 0;
  overflow: hidden;
  background: $color-bg-2;
  border: 1px solid $color-border;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.expert-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}

.expert-title {
  align-self: flex-start;
  margin-bottom: 8px;
  padding: 3px 10px;
  font-size: 12px;
  letter-spacing: 1px;
  color: $color-text-2;
  background: $color-bg-2;
  border: 1px solid $color-border;
}

.expert-name {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: $color-text;
  letter-spacing: 1px;
}

.expert-bio {
  margin: 8px 0 0;
  font-size: 13px;
  line-height: 1.7;
  color: $color-text-2;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

// 合作伙伴(flex 居中,li 只负责列布局,无边框无底色,纯 logo 展示)
.partner-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;

  li {
    // 8 列均分宽度,li 是纯布局容器,不承担视觉样式
    width: calc((100% - 7 * 12px) / 8);
    height: 96px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    background: transparent;
    border: none;

    img {
      max-width: 100%;
      max-height: 100%;
      display: block;
      object-fit: contain;
    }
  }
}

.dialog-img {
  width: 100%;
  display: block;
  border: 1px solid $color-border;
}

// 响应式
@media (max-width: 1100px) {
  .honor-grid { grid-template-columns: repeat(4, minmax(0, 1fr)); }
  .partner-grid li { width: calc((100% - 5 * 12px) / 6); }
}

@media (max-width: 960px) {
  .intro {
    grid-template-columns: 1fr;

    .intro-photo { height: 240px; }
  }

  .honor-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .partner-grid li { width: calc((100% - 3 * 12px) / 4); }
}

@media (max-width: 640px) {
  .block-head h3 { font-size: 18px; }

  .page-nav-item { padding: 11px 16px; font-size: 13px; }

  .culture {
    padding: 20px 16px;
    .culture-slogan { font-size: 16px; }
    .culture-items { grid-template-columns: 1fr; }
  }

  .honor-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .partner-grid li { width: calc((100% - 2 * 12px) / 3); }

  // 时间轴窄屏:item 缩到 140px,继续横向滚动不换行
  .timeline-h-item { flex-basis: 140px; min-width: 140px; }

  // 核心团队窄屏:单列堆叠
  .expert-grid { grid-template-columns: 1fr; }
  .expert-card { padding: 16px; gap: 16px; }
  .expert-photo { width: 80px; height: 80px; }
  .expert-name { font-size: 16px; }
}
</style>

<!-- 时间轴 tooltip 内容样式(Element UI 弹出层在 body 下,scoped 匹配不到,放全局) -->
<style lang="scss">
.timeline-tip-body {
  max-width: 280px;
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.6;
  text-align: left;
}

// 核心团队 tooltip(同 发展历程 模式,卡片默认 3 行截断,hover 弹完整 bio)
.expert-tip-body {
  max-width: 320px;
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.7;
  text-align: left;
}
</style>
